import type { IconSvgObject } from './types';

const BluetoothSearchingIcon: IconSvgObject = [
  ["path", { d: "M4.99609 17L14.9961 6.99997L9.9975 3V21L14.9961 17L4.99609 6.99997", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.1314 9.49C18.698 10.2006 19.0057 11.0829 19.0039 11.9918C19.0021 12.9006 18.6908 13.7817 18.1214 14.49M14.9961 11.99L14.9961 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BluetoothSearchingIcon;
